import {ofType} from 'redux-observable';
import {of, from, EMPTY, merge} from 'rxjs';
import i18next from 'i18next';
import {flatMap, catchError, map} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {setLocale} from 'web-app/util/locale';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Actions from './actions';
import * as Api from './api';

export const fetchAccountDetailsObservable = () => {
    return from(Api.fetchAccount()).pipe(map(() => Actions.fetchDetailsSuccess.action()));
};

const fetchDetails = action$ =>
    action$.pipe(
        ofType(Actions.fetchDetails.type),
        flatMap(() => {
            return fetchAccountDetailsObservable().pipe(catchError(e => of(Actions.fetchDetailsFailed.action(e))));
        }),
    );

export const updateAccountDetailsObservable = ({
    firstName,
    middleName,
    lastName,
    street,
    zip,
    city,
    phone,
    homePhone,
    workPhone,
    locale,
    timezone,
    languageUpdated,
}: {
    firstName: string;
    middleName: string;
    lastName: string;
    street: string;
    zip: string;
    city: string;
    phone: string;
    homePhone: string;
    workPhone: string;
    locale: string;
    timezone?: string;
    languageUpdated?: boolean;
}) =>
    Api.updateAccount(
        firstName,
        middleName,
        lastName,
        street,
        zip,
        city,
        phone,
        homePhone,
        workPhone,
        locale,
        timezone,
    ).pipe(
        flatMap(response => {
            if (languageUpdated) {
                setLocale(locale);
                setTimeout(() => window.location.reload(), 100);
                return EMPTY;
            }
            return fetchAccountDetailsObservable().pipe(
                flatMap(accountAction => {
                    return merge(of(accountAction), of(Actions.updateDetailsSuccess.action(response)));
                }),
            );
        }),
    );

const updateDetails = action$ =>
    action$.pipe(
        ofType(Actions.updateDetails.type),
        flatMap(({payload}) =>
            updateAccountDetailsObservable({
                firstName: payload.data.firstName,
                middleName: payload.data.middleName,
                lastName: payload.data.lastName,
                street: payload.data.street,
                zip: payload.data.zipCode,
                city: payload.data.city,
                phone: payload.data.phone,
                homePhone: payload.data.homePhone,
                workPhone: payload.data.workPhone,
                locale: payload.data.language,
                languageUpdated: payload.languageUpdated,
            }).pipe(
                flatMap(action => {
                    if (action && action.type === Actions.updateDetailsSuccess.type) {
                        return [action, GlobalEventActions.updateSuccess.action(i18next.t('account.profileUpdated'))];
                    }
                    return [action];
                }),
                catchError(e => of(Actions.updateDetailsFailed.action(e))),
            ),
        ),
    );

export default combineEpics(fetchDetails, updateDetails);
